import React, { memo } from 'react';

// Components
import Img from 'components/Img';

// Classes
import clsx from 'clsx';

// Type
import { CartProductProps } from 'pages/Search/type';

type typeTabs = {
	[key: string]: string
}

// Interface
interface INoData {
	type: string;
	isHiddeValue?: boolean;
	data?: CartProductProps[];
}

export const NoData: React.FC<INoData> = (props) => {
	const {
		data,
		type,
		isHiddeValue = false
	} = props;

	const cn = clsx(
		data?.length ? '' : 'search-screen__list--active',
		'search-screen__list-not-found'
	);

	const getValueCurrent: HTMLInputElement | null = document.querySelector('.input-debounce__input');
	const typeTabs: typeTabs = {
		compounds: 'compound',
		libraries: 'library',
		drugs: 'drug',
		impurities: 'impurity',
		chemicalProbes: 'chemical probe'
	};

	const variable = typeTabs[type];

	return <div className={cn}>
		<Img
			alt="Empty icon"
			name="searchEmpty"
			className="search-screen__empty-icon"
		/>
		{!!getValueCurrent?.value && <>
			<p className="search-screen__empty-text">
				We didn't find any {variable}
			</p>

			{!isHiddeValue && <p className="search-screen__empty-current-text">
				"{getValueCurrent?.value || ''}"
			</p>}
		</>}
	</div>;
}
	export default memo(NoData);
